import { useContext } from 'react';
import { DataAccessContext } from '@chargify/data-access';

export const useDataAccess = () => useContext(DataAccessContext);
